import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ui/button';
import { InputWrapperContainer } from '../../input/inputWrapper.container';
import { trans } from '../../../modules/translation/translate';
import SeedStoreController from '../../../../../common/components/storeControllers/SeedStoreController';
import { Loader } from '../../loader/loader';

class ServerSeedInput extends React.PureComponent {
	static propTypes = {
		value: PropTypes.any,
		onClick: PropTypes.func,
		changeAsRedirect: PropTypes.bool,
		pauseAutobet: PropTypes.func,
		autobetPaused: PropTypes.bool,
		setConfirm: PropTypes.func,
		goTo: PropTypes.func,
	};

	componentDidMount() {
		this.props.pauseAutobet(true);
	}

	componentWillUnmount() {
		this.props.pauseAutobet(false);
	}

	onClick = () => {
		if (this.props.changeAsRedirect) {
			return this.props.goTo('provablyFair?tab=session');
		}
		if (this.props.autobetPaused) {
			return this.props.setConfirm({
				callback: this.props.onClick,
				question: trans({
					label:
						'I am aware that changing my server seed hashed will affect next bets in current autobet session',
				}),
			});
		}
		this.props.onClick();
	};

	render() {
		return (
			<>
				<SeedStoreController />
				<InputWrapperContainer
					value={this.props.value}
					name={'server-seed-hashed'}
					label={trans({ label: 'Current server seed (hashed)' })}
					isDisabled={true}
					inputButtons={[
						<Button
							key={1}
							name="generate-new-server-seed"
							onClick={this.onClick}
							label={trans({ label: 'Change' })}
						>
							<Loader loader="reloadServerSeed" />
						</Button>,
					]}
				/>
			</>
		);
	}
}

export { ServerSeedInput };
